import axios from 'axios';

import ApiService from './ApiService';

import { IPaginatedData } from 'common/interfaces/pagination';
import { ITableParams } from 'common/interfaces/table';
import { IDictionaryCommonItem } from 'modules/dictionaries/interfaces/interfaces';

export default class AdditionalGuestFieldsService extends ApiService {
  public getAdditionalGuestFields = (
    requestOptions?: ITableParams,
  ): Promise<IPaginatedData<IDictionaryCommonItem>> => {
    const searchParams = this.getSearchFromTableParams(requestOptions);
    return axios.get('/api/v1/additional-fields', { params: searchParams });
  };

  public createAdditionalGuestField = (
    data: IDictionaryCommonItem,
  ): Promise<IDictionaryCommonItem> => {
    return axios.post('/api/v1/additional-fields', data);
  };

  public updateAdditionalGuestField = (
    data: IDictionaryCommonItem,
  ): Promise<IDictionaryCommonItem> => {
    return axios.put(`/api/v1/additional-fields/${data.id}`, data);
  };

  public updateStatusAdditionalGuestField = (
    id: string,
    isActive: boolean,
  ): Promise<IDictionaryCommonItem> => {
    return axios.patch(`/api/v1/additional-fields/${id}/change-status`, { active: isActive });
  };
}
